// Dependencies imports
import React from "react";

import Bu from "./roimaker.module.scss";

const Button = ({ name, onClick }) => {
  return (
    <button className={Bu.continuebutton} onClick={onClick}>
      {name}
    </button>
  );
};

export default Button;
